import firebase from "firebase/compat/app";
import formatChallengeData from "../utils/formatChallengeData";

const getChallengeInfoById = async function(id) {
  let db = firebase.firestore();

  const challengeSnapshot = await db
    .collection("wellness_competition")
    .doc(id)
    .get();
  return formatChallengeData(id, challengeSnapshot.data());
};

export default getChallengeInfoById;
